import React from 'react';
import PropTypes from 'prop-types';

// Components
import {Icon, Info} from '@drivesally/sally-ui';
import Card from './components/Card';
import Title from './components/Title';
import IconBadge from './components/IconBadge';

// Attributes
import dynamicFieldAttribute from '../../attributes/dynamicField.attribute.gas';

// Shared by GasSectionCard (the main grid) and GasPictureRow (the pictures
// listing) - title bar, override banner, and "who/when set this" banner are
// identical in both places, only the body content underneath differs.
const GasSectionCardShell = ({section, gas, children}) => {
  const {label, icon, status, override, overrideReason} = section;
  const overriddenBy = !!override && gas?.[override];
  const overriddenReason = !!overriddenBy && !!overrideReason && gas?.[overrideReason];

  const meta = gas?.section_field_meta?.[section.key];
  const modifiedBy = meta?.modified_by_field && gas?.[meta.modified_by_field];
  const modifiedAtValue = meta?.modified_at_field && gas?.[meta.modified_at_field];
  const modifiedAtDisplay = !!modifiedAtValue
    ? dynamicFieldAttribute(
        {field: meta.modified_at_field, label: 'Modified At', type: 'datetime'},
        modifiedAtValue
      ).display.format()
    : null;

  return (
    <Card status={status?.status}>
      <Title>
        <IconBadge status={status?.status}>
          <Icon icon={icon} />
        </IconBadge>
        {label}
      </Title>
      {!!overriddenBy && (
        <Info type="warning" noIcon flat>
          Overridden by {overriddenBy}
          {!!overriddenReason && `. Reason: ${overriddenReason}.`}
        </Info>
      )}
      {!!modifiedBy && (
        <Info type="info" noIcon flat>
          Set by {modifiedBy}
          {!!modifiedAtDisplay && ` on ${modifiedAtDisplay}`}
        </Info>
      )}
      {children}
    </Card>
  );
};

GasSectionCardShell.propTypes = {
  section: PropTypes.object.isRequired,
  gas: PropTypes.object,
  children: PropTypes.node,
};

export default GasSectionCardShell;
